import { Button, FormContainer, Modal, Flex } from '@wyz/ui';
import { useForm } from 'react-hook-form';
import { TextField } from '~/common/components';
import { Trans } from '~/common/context';

type ContainerOrderConfirmationModalProps = {
  onClose: () => void;
  onSuccess: (comment?: string) => void;
};

function ContainerOrderConfirmationModal({
  onClose,
  onSuccess,
}: ContainerOrderConfirmationModalProps) {
  const methods = useForm<{ comment?: string }>({
    defaultValues: {
      comment: '',
    },
  });

  return (
    <Modal.Container open={true} onClose={onClose} size='lg' backdrop='static'>
      <Modal.Header>
        <Modal.Title>
          <Trans i18nKey='app.container.order.result.comment' />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormContainer
          methods={methods}
          submitHandler={(form) => {
            onSuccess(form.comment);
          }}
        >
          <TextField name='comment' type='text' as='textarea' rows={6} />
          <Flex className='space-x-2'>
            <Button
              id='cancel-comment'
              variant='secondary'
              // disabled={manageRedistributionOrders.cancel.isLoading}
              onClick={onClose}
              fullWidth
            >
              <Trans i18nKey='app.common.button.cancel' />
            </Button>
            <Button
              id='submit-comment'
              variant='primary'
              type='submit'
              // isLoading={manageRedistributionOrders.cancel.isLoading}
              fullWidth
            >
              <Trans i18nKey='app.common.buttons.validate' />
            </Button>
          </Flex>
        </FormContainer>
      </Modal.Body>
    </Modal.Container>
  );
}

export default ContainerOrderConfirmationModal;
